import { IconButton, IconButtonProps, Tooltip } from '@mui/material'
import { Brightness4, Brightness7 } from '@mui/icons-material'
import useTheme from '../hooks/useTheme'
import { THEMES } from '../constants'
import { useTranslation } from 'react-i18next'

type ThemeButtonProps = Omit<IconButtonProps, 'onClick'>

const ThemeButton = (props: ThemeButtonProps) => {
  /**
   * The translate function.
   */
  const [t] = useTranslation('common')

  /**
   * The theme.
   */
  const { theme, setTheme } = useTheme()

  /**
   * Handles the theme change.
   */
  const handleChangeTheme = () => {
    if (theme === THEMES.LIGHT) {
      setTheme(THEMES.DARK)
    } else {
      setTheme(THEMES.LIGHT)
    }
  }

  return (
    <Tooltip title={t('Navbar.switchTheme') as string}>
      <IconButton {...props} onClick={handleChangeTheme}>
        {theme === '"DARK"' ? (
          <Brightness7 fontSize="inherit" />
        ) : (
          <Brightness4 fontSize="inherit" />
        )}
      </IconButton>
    </Tooltip>
  )
}

export default ThemeButton
